export const primaryBorder = "1px solid rgba(188,188,188,0.5)";
export const primaryShadow = "0px 1px 2px rgba(0, 0, 0, 0.05)";
export const errorBorder = "1px solid red";
